import type { ReactElement } from 'react';
import { Controller } from 'react-hook-form';
import { IncrementalQuantityField } from '../../../components/forms/incremental-quantity-field.tsx';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { ProductVariantDTO } from '../../../server/dto/product-variant-dto.ts';
import { useAddProductForm } from '../hooks/use-add-product-form.ts';

export type ProductQuickAddProps = {
    product: ProductVariantDTO;
    variant?: 'secondary';
};

export function ProductQuickAdd({ product, variant }: ProductQuickAddProps): ReactElement {
    const { t } = useLocale('product-details');

    const { control, onSubmit, salesConfig, salesUnit } = useAddProductForm({
        product,
        source: 'product_detail_page',
    });

    return (
        <div className="flex items-center space-x-3">
            <Controller
                control={control}
                name="quantity"
                render={({ field }) => (
                    <IncrementalQuantityField
                        className="w-[200px]"
                        value={field.value}
                        onValueChange={field.onChange}
                        partialPackingType={salesConfig?.partial_packing_type}
                        quantityUnit={salesUnit ?? ''}
                        salesUnitsPerPackageUnit={salesConfig?.sales_units_per_package_unit}
                    />
                )}
            />
            <Button variant={variant} onClick={onSubmit}>
                {t('quick_add')}
            </Button>
        </div>
    );
}
